module.exports = {"Type":"Link","Disabled":true,"Fields":[{"name":"choice","label":"Button label "},{"name":"choiceValue","label":"Chat text"},{"name":"speak","type":"multiline","label":"Speak"},{"name":"alternateIntents","type":"intents","label":"Alternate Intents"},{"name":"alternateEntities","type":"entities","label":"Alternate Entities"},{"name":"alternateKeywords","label":"Alternate Keywords"},{"name":"url","label":"Url"},{"name":"imageUrl","label":"Image Url"},{"name":"order","label":"Order"}],"Header":{"Color":"white","BackgroundColor":"brown","Text":"LOGIN"}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Link.json
// module id = 1028
// module chunks = 0